module.exports = __webpack_public_path__ + "img/Warning.c81ed02a.svg";